import type { QueryClient } from '@tanstack/react-query';
import { configureClient } from 'markcat-api-client';
import { useAuthStore } from './stores/auth';

/**
 * Wire the API client to the app's auth store and query cache.
 *
 * No getRefreshToken: the cloud web app uses the HttpOnly `markcat_refresh`
 * cookie (set by the server, sent automatically with `credentials: 'include'`),
 * so refresh runs in cookie mode.
 *
 * `queryClient.clear()` on auth failure drops the previous tenant's cached data
 * BEFORE the redirect — without it, a guard re-render between logout and nav
 * could hand stale bookmarks to the next logged-in user for one render.
 */
export function configureApiClient(queryClient: QueryClient, baseUrl: string): void {
  configureClient({
    baseUrl,
    getAccessToken: () => useAuthStore.getState().accessToken,
    onTokenRefreshed: (token) => {
      useAuthStore.getState().setAccessToken(token);
    },
    onAuthFailed: () => {
      queryClient.clear();
      useAuthStore.getState().logout();
      window.location.href = '/login';
    },
  });
}
